import React from 'react';
import { Circle, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface CircleMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    opacity: number;
    isAnimated: boolean;
    showTooltip: boolean;
    onClick?: (event: any) => void;
}

export const CircleMarker = (props: CircleMarkerProps) => {
    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    return (
        <Circle
            pane="markerPane"
            key={`${props.key}-${props.opacity}`}
            center={props.position}
            radius={props.radius}
            eventHandlers={{
                click: handleClick,
            }}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Circle>
    );
};
